export interface IAisEnable {
  'module-AIS': boolean
}

export const getDefaultAisEnable = (): IAisEnable => {
  return {
    'module-AIS': false
  }
} 
  